import { createElement } from 'react';

import { Report } from '../../../../../../types/Reports';
import DefaultActions from './DefaultActions';
import ReportAcademicActions from './ReportAcademicActions';
import ReportAuditOfGradesActions from './ReportAuditOfGradesActions';
import StudentsWithoutEmail from './StudentsWithoutEmailActions';
import TeacherAttendanceActions from './TeacherAttendanceActions';
import TuitionsContinuityPeriodActions from './TuitionsContinuityPeriodActions';
import TuitionsPeriodConsolidatedActions from './TuitionsPeriodConsolidatedActions';
import ReportTeachersOccupation from './ReportTeachersOccupation';
import ReportSpacesOccupation from './ReportSpacesOccupation';

const getActionsByReportType = (reportType: Report['type']) => {
  const COMPONENTS: any = {
    STUDENTS_WITHOUT_EMAIL: StudentsWithoutEmail,
    LESSONS_TEACHER: TeacherAttendanceActions,
    TUITIONS_PERIOD_CONSOLIDATED: TuitionsPeriodConsolidatedActions,
    ACADEMIC: ReportAcademicActions,
    TUITIONS_CONTINUITY_PERIOD: TuitionsContinuityPeriodActions,
    AUDIT_OF_GRADES: ReportAuditOfGradesActions,
    TEACHERS_OCCUPATION: ReportTeachersOccupation,
    SPACES_OCCUPATION: ReportSpacesOccupation,
    DEFAULT: DefaultActions,
  };

  return COMPONENTS[reportType] || COMPONENTS.DEFAULT;
};

interface Props {
  report: Report;
  onPressDownload: () => void;
}

export default function ReportActionsCell({ report, onPressDownload }: Props) {
  const { type, downloadUrl, renderSide } = report;
  return createElement(getActionsByReportType(type), {
    downloadUrl,
    renderSide,
    onPressDownload,
  });
}
